<template>
    <div class="text-center align-items-center justify-content-center">
        <img src="img/escudo.png" alt="SEDATU" style="opacity: 0.25; width:100%">
    </div>
</template>

<script>
    export default {
        name: "Background"
    }
</script>

<style scoped>

</style>
